import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAlert from "../../../../hooks/useAlert";
import { validateBrandAdd } from "../../../../utils/validation";
import {
  addBrandAction,
  brandUpdate,
} from "../../../../redux/actions/BrandAction";
import { Update } from "@mui/icons-material";
import { IoMdSave } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import PropTypes from "prop-types";

export const BrandUpdate = ({ openDialog, handleCloseDialog, data }) => {
  const { showSuccessBrandAdded, showErrorBrandAdded } = useAlert();
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const dispatch = useDispatch();
  const [value, setValue] = useState({
    id: data?.id,
    name: data?.name || "",
    userId: authUserId,
    ia: true,
  });
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    setValue(data);
  }, [data, authUserId]);

  const handleInputChange = (e) => {
    const { name, value: inputValue } = e.target;
    setValue((prev) => ({ ...prev, [name]: inputValue }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const updateBrand = async (e) => {
    e.preventDefault();

    const errors = validateBrandAdd(value);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(brandUpdate(value, token));
        showSuccessBrandAdded();
        handleCloseDialog();
      } catch {
        showErrorBrandAdded();
      }
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "95%", sm: "500px" },
          maxWidth: "500px",
          margin: { xs: 2, sm: 4 },
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
          padding: { xs: 1.5, sm: 2 },
          marginBottom: { xs: 2, sm: 3 },
          fontSize: { xs: "1.1rem", sm: "1.25rem" },
        }}
      >
        Marka Güncelle
      </DialogTitle>
      <DialogContent sx={{ padding: { xs: 2, sm: 3 } }}>
        <Grid container spacing={{ xs: 1.5, sm: 2 }}>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              label="Marka ismi"
              variant="outlined"
              placeholder="Marka ismi"
              value={value?.name}
              name="name"
              onChange={handleInputChange}
              error={!!formErrors.name}
              helperText={formErrors.name}
              sx={{
                "& .MuiOutlinedInput-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          padding: { xs: 2, sm: 3 },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1.5, sm: 1 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 1.5, sm: 1 },
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            startIcon={<IoMdClose />}
            onClick={handleCloseDialog}
            sx={{
              color: "#29275D",
              borderColor: "#29275D",
              textTransform: "none",
              borderRadius: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              padding: { xs: "8px 16px", sm: "6px 12px" },
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#f1f1f1",
              },
            }}
          >
            Kapat
          </Button>

          <Button
            variant="contained"
            startIcon={<IoMdSave />}
            onClick={updateBrand}
            sx={{
              backgroundColor: "#29275D",
              color: "#fff",
              textTransform: "none",
              borderRadius: 2,
              fontSize: { xs: "0.875rem", sm: "1rem" },
              padding: { xs: "8px 16px", sm: "6px 12px" },
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#1f1b45",
              },
            }}
          >
            Kaydet
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

BrandUpdate.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
};
